import { NgClass, NgForOf, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { IMasterDupePair, IMergeLog } from '../../../../shared/interfaces/duplikit-interfaces';
import { DuplikitMergeLogService } from '../../duplikit-merge-log.service';

@Component({
  selector: 'app-association-merges',
  templateUrl: './duplikit-history-association-merges.component.html',
  imports: [
    NgIf,
    NgForOf,
    NgClass,
    MatTooltip
  ],
  styleUrls: ['./duplikit-history-association-merges.component.scss']
})
export class DuplikitHistoryAssociationMergesComponent implements OnInit {
  @Input() masterDupePair: IMasterDupePair;
  mergeLogs: IMergeLog[];
  mergeLogsLoading = true;

  constructor(
    private mergeLogService: DuplikitMergeLogService,
  ) { }

  ngOnInit() {
    this.mergeLogService.getAssociatedMergesForMasterDupePair(
      this.masterDupePair.dedupeTaskId,
      this.masterDupePair.masterId,
      this.masterDupePair.duplicateId
    ).subscribe((data) => {
        console.log(data);
        this.mergeLogs = data;
        this.mergeLogsLoading = false;
    });
  }

}
